import React from 'react';

const Settings = () => {
  return (
    <div>
      <h1>Configurações</h1>
      <p>Esta é a página de configurações.</p>
    </div>
  );
};

export default Settings;